import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { EVOTRUX_BORDER_GREY } from "constants/index";
import { formatCentsToDollars } from "utils";

interface TfcReadOnlyTableProps {
  lineItems: TfcLineItem[];
  totalCents: number;
  currency: string;
  bookedPriceCents: number | null;
}

export function TfcReadOnlyTable(props: TfcReadOnlyTableProps) {
  const { lineItems, totalCents, currency, bookedPriceCents } = props;
  const fontSize = "16px";

  return (
    <Box
      sx={{
        border: `1px solid ${EVOTRUX_BORDER_GREY}`,
        borderRadius: "4px",
        overflow: "hidden",
      }}
    >
      <TableContainer>
        <Table size="medium">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700, fontSize, py: "5px" }}>
                Description
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  fontSize,
                  py: "5px",
                  width: "150px",
                }}
              >
                Amount
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  fontSize,
                  py: "5px",
                  width: "70px",
                }}
              >
                Currency
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bookedPriceCents != null && (
              <TableRow>
                <TableCell sx={{ py: "5px" }}>
                  <Typography
                    sx={{ fontWeight: 500, fontSize, color: "#4B5563" }}
                  >
                    Booked Price
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: "5px" }}>
                  <Typography
                    sx={{ fontWeight: 500, fontSize, color: "#4B5563" }}
                  >
                    ${formatCentsToDollars(bookedPriceCents)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: "5px" }}>
                  <Typography
                    sx={{ fontWeight: 500, fontSize, color: "#4B5563" }}
                  >
                    {currency}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {lineItems.map((item) => (
              <TableRow key={item.id}>
                <TableCell sx={{ py: "5px" }}>
                  <Typography sx={{ fontSize, wordBreak: "break-word" }}>
                    {item.description}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: "5px" }}>
                  <Typography sx={{ fontSize }}>
                    ${formatCentsToDollars(item.line_total_cents)}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: "5px" }}>
                  <Typography sx={{ fontSize }}>{currency}</Typography>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell sx={{ py: "5px", borderBottom: "none" }}>
                <Typography sx={{ fontWeight: 700, fontSize }}>
                  Total Freight Cost
                </Typography>
              </TableCell>
              <TableCell sx={{ py: "5px", borderBottom: "none" }}>
                <Typography sx={{ fontWeight: 700, fontSize }}>
                  ${formatCentsToDollars(totalCents)}
                </Typography>
              </TableCell>
              <TableCell sx={{ py: "5px", borderBottom: "none" }}>
                <Typography sx={{ fontWeight: 700, fontSize }}>
                  {currency}
                </Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
